import { classNames } from '@/utils/classNames';
import styles from './ContentContainer.module.css';

interface ContentContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const ContentContainer = ({ children, className, style }: ContentContainerProps) => {
  const containerClassName = classNames(styles.contentContainer, className);

  return (
    <div className={containerClassName} style={style}>
      {children}
    </div>
  );
};
